import React, { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { pm } from 'lib/helpers/utility';
import { useTransactions } from 'lib/hooks/queries/billing/useTransactions';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { getColDefs } from 'components/shared/Transactions/components/lib/configs';
import state from 'components/state';

import HeaderActions from './HeaderActions';
import { DEFAULT_FILTERS } from './configs';

const TransactionsTable = ({ patient_id }) => {
  const { id } = useParams();
  const patientId = patient_id || id;
  const permissions = useRecoilValue(state.permissions);
  const [_, setSearchParams] = useSearchParams();
  const columnDefs = useMemo(() => getColDefs({ isFromPatient: true }), []);

  return (
    <>
      <AgTablePage
        defaultColumns={columnDefs}
        defaultFilters={DEFAULT_FILTERS}
        useData={useTransactions}
        name="myportal_transactions"
        queryKey="transactions"
        title="Payments"
        noTitle
        rowStyle={{ cursor: 'pointer' }}
        queryParams={{ patientId }}
        onSelectRow={(data) => {
          if (pm(permissions, 'is_admin')) {
            setSearchParams({ txnResponseId: data?.id });
          }
        }}
        headerActions={HeaderActions}
      />
    </>
  );
};

export default TransactionsTable;
